/* eslint-disable no-script-url */
import store from '@/store';

export interface NavItem {
  name: string;
  path?: string;
  routeNames?: string[];
  action?: () => void;
  condition?: () => boolean;
}

export const MAIN_NAV_ITEMS = (router: any): NavItem[] => [
  {
    name: 'Home',
    path: '/',
    routeNames: ['Home'],
    condition: () => !store.getters.getCurrentUser,
  },
  {
    name: 'Pricing',
    path: '/pricing',
    routeNames: ['Pricing'],
    condition: () => !store.getters.getCurrentUser,
  },
  {
    name: 'Dashboard',
    path: '/dashboard',
    routeNames: ['Dashboard'],
    condition: () => store.getters.getCurrentUser,
  },
  {
    name: 'Keywords',
    path: '/keywords',
    routeNames: ['Keywords'],
    condition: () => store.getters.getCurrentUser,
  },
  // {
  //   name: 'Calendar',
  //   path: '/content',
  //   routeNames: ['Sprints', 'SprintCalendar', 'Calendar', 'ContentBrief'],
  //   condition: () => store.getters.isAuthenticated,
  // },
  {
    name: 'Sprints',
    path: '/sprints',
    routeNames: ['Sprints', 'SprintCalendar', 'Calendar', 'ContentBrief'],
    condition: () => store.getters.getCurrentUser,
  },
  // {
  //   name: 'Admin Dashboard',
  //   path: '/admin',
  //   condition: () => store.getters.isAdmin,
  // },
  {
    name: 'Sign in',
    path: '/login',
    condition: () => !store.getters.getCurrentUser,
  },
  {
    name: 'Sign Out',
    action: async () => {
      await store.dispatch('user/logout');
      router.push({ name: 'Login' });
    },
    condition: () => store.getters.getCurrentUser,
  },
];
